"use client";

import debounce from "lodash/debounce";
import React from "react";

export const useScrollSpyOnUpdate = ({
  initialState = "",
  debounceDelay = 250,
  querySelector = ".anchor-active a"
}) => {
  const [currentAnchor, setCurrentAnchor] = React.useState(initialState);
  const scrollSpyUpdate = debounce(() => {
    const targetElement = document.querySelector(
      querySelector
    ) as HTMLAnchorElement;
    if (!!targetElement && targetElement.href) {
      const hrefParts = "#" + targetElement.href.split("#");
      if (hrefParts.length > 1) {
        const href = hrefParts[1];
        window.history.replaceState("", "", href);
        setCurrentAnchor(href);
      }
    }
  }, debounceDelay);
  return {
    currentAnchor,
    setCurrentAnchor,
    scrollSpyUpdate
  };
};
